/**
 * Sequences {@link PlaybackEvent}s in the user's project. The
 * various implementations of this class are used by different
 * block modes (i.e. programming models) we currently support.
 */
var Sequencer = /** @class */ (function () {
    function Sequencer() {
    }
    return Sequencer;
}());
export default Sequencer;
